import axios from "axios";

// KYC document files that are not tied to one record's route
// (snb_lightspeed_backend docs/customer-module/kyc/13-Slice-2-Full-Replacement.md
// §4 "Files", 03-File-Storage.md §5-§6). The uploads themselves go through the
// record: customerapplications/uploadApplicationFile and
// changerequests/uploadChangeRequestFile.
//
// Every action resolves to the whole envelope (res.data) and rejects with what
// the global interceptor rejects with: the axios response.
export default {
    namespaced: true,

    state: {},

    getters: {},

    mutations: {},

    actions: {
        // GET /files/{file_id}/download?purpose=download|preview|review&disposition=attachment|inline
        // data: {url, expires_at, file_name, mime, disposition}; the url is
        // valid 60 s. attachment (the default): the browser downloads straight
        // from it (shared/kycFiles.js); inline: the file viewer shows it in
        // place (<img src>, <iframe src>).
        async downloadUrl({ commit }, { fileId, purpose, disposition }) {
            const params = { purpose: purpose || "download", disposition: disposition || "attachment" };
            return await axios
                .get(`/api/v1/files/${fileId}/download`, { params })
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },

        // DELETE /files/{file_id}: the uploader's own pending file (200, no data);
        // an attached file is 422 under data.file_id
        async discardFile({ commit }, fileId) {
            return await axios
                .delete(`/api/v1/files/${fileId}`)
                .then((res) => res.data)
                .catch((err) => Promise.reject(err));
        },
    },
};
